import React from 'react';
import { Link } from 'react-router-dom';
import { Tv, Star } from 'lucide-react';

const SeriesCard = ({ series, showRating = true }) => {
  return (
    <Link
      to={`/series/${series.id}`}
      className="group block"
    >
      <div className="relative aspect-[2/3] overflow-hidden rounded-lg bg-[#1a2420]">
        {series.poster ? (
          <img
            src={series.poster}
            alt={series.name || series.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Tv className="w-12 h-12 text-[#52ea88]/30" />
          </div>
        )}
        
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F0E] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        
        {/* Rating badge */}
        {showRating && series.vote_average > 0 && (
          <div className="absolute top-2 right-2 flex items-center gap-1 bg-[#0B0F0E]/80 px-2 py-1 rounded text-sm">
            <Star className="w-3 h-3 text-[#52ea88] fill-[#52ea88]" />
            <span className="text-[#E6FFF6]">{series.vote_average.toFixed(1)}</span>
          </div>
        )}
        
        {/* TV badge */}
        <div className="absolute top-2 left-2 bg-[#52ea88] text-[#0B0F0E] text-xs font-semibold px-2 py-1 rounded">
          TV
        </div>
      </div>
      
      <div className="mt-3">
        <h3 className="font-medium text-[#E6FFF6] group-hover:text-[#52ea88] transition-colors line-clamp-2">
          {series.name || series.title}
        </h3>
        {series.year && (
          <p className="text-sm text-[#9FBFB4] mt-1">{series.year}</p>
        )}
      </div>
    </Link>
  );
};

export default SeriesCard;
